import { Box, useTheme } from '@mui/material';
import React, { ReactNode } from 'react';

import Heading, { headingCID } from '../Heading';

import CardFloat from './CardFloat';
import { cardClassIdentifier } from './sharedCardStyles';

export interface CardHeaderProps {
  /** The float content floats to the top right */
  float?: ReactNode;
  title: string;
}

const PADDING_INLINE = 6;

/**
 * Holds a header and menu items that float to the top right of the card
 * @returns {component} Component
 */
const CardHeader = ({ children, float, title }: React.PropsWithChildren<CardHeaderProps>): JSX.Element => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        [`.${cardClassIdentifier} &`]: {
          marginRight: '-.7rem',
          paddingLeft: 0,
        },
        display: 'flex',
        marginBottom: '.5rem',
        paddingLeft: theme.spacing(PADDING_INLINE),
        paddingRight: theme.spacing(PADDING_INLINE),
      }}
    >
      <Box
        sx={{
          [`& .${headingCID}`]: {
            marginBottom: 0,
          },
          flex: 1,
        }}
      >
        <Heading>{title}</Heading>
        {children}
      </Box>
      {float && <CardFloat>{float}</CardFloat>}
    </Box>
  );
};

export default CardHeader;
